import { render, staticRenderFns } from "./store.vue?vue&type=template&id=96c3dc08"
import script from "./store.vue?vue&type=script&lang=ts"
export * from "./store.vue?vue&type=script&lang=ts"
import style0 from "./store.vue?vue&type=style&index=0&id=96c3dc08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports